/* @flow */
import React, { Component } from 'react';

import MediaQueries from '../../constants/MediaQueries';

class Image extends Component<{
  src: string,
  src2x?: string,
  alt?: string,
  style?: any,
}> {
  render() {
    let retinaMediaQuery = window.matchMedia(MediaQueries.js(MediaQueries.Retina));
    let { alt, src, src2x, style, ...rest } = this.props;
    let srcToUse = retinaMediaQuery.matches && !!src2x ? src2x : src;

    return <img src={srcToUse} alt={alt} style={{ verticalAlign: 'middle', ...style }} {...rest} />;
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/ui/components/core/Image.js